module.exports = __webpack_public_path__ + "media/ding.902e6a0b.wav";